<template>
  <svg v-if="remove" v-on="$listeners" width="11" height="11" xmlns="http://www.w3.org/2000/svg">
    <g
      fill="none"
      stroke="#B8B8B8"
      stroke-width="1.375"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M.688 10.063L10.062.687M10.063 10.063L.687.687" />
    </g>
  </svg>
  <svg v-else-if="upload" width="28" height="20" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="currentColor" stroke-width="1.38">
      <path d="M13.69 16.29V6.757" />
      <path d="M9.357 11.09l4.333-4.333 4.333 4.333" stroke-linecap="square" />
      <path
        d="M17.157 18.023h5.2c2.429-.219 4.333-2.28 4.333-4.766 0-2.5-1.927-4.548-4.377-4.747A8.664 8.664 0 005.398 6.839 5.631 5.631 0 00.69 12.39c0 2.965 2.292 5.412 5.2 5.633h4.332"
        stroke-linecap="square"
      />
    </g>
  </svg>
  <svg v-else-if="drop" width="80" height="80" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fill-rule="nonzero"><path d="M66.667 25a3.333 3.333 0 00-3.334-3.333H40a3.333 3.333 0 100 6.666h23.333A3.333 3.333 0 0066.667 25zM41.667 36.667a3.333 3.333 0 100 6.666H55a3.333 3.333 0 100-6.666H41.667z"/><path d="M78.047 10L70 1.95A6.669 6.669 0 0065.287 0h-38.62A6.667 6.667 0 0020 6.667v24.25a.827.827 0 00.807.833c1.22.02 3.46.113 4.95.277a.82.82 0 00.91-.827V8.333c0-.92.746-1.666 1.666-1.666h36.264c.44 0 .864.175 1.176.486l7.074 7.074c.311.312.486.735.486 1.176V60c0 .92-.746 1.667-1.666 1.667h-22.86a.817.817 0 00-.804.7 26.52 26.52 0 01-1.213 4.86.813.813 0 00.76 1.103h25.783A6.667 6.667 0 0080 61.663V14.715c0-1.77-.703-3.466-1.955-4.716l.002.001z"/><path d="M21.667 36.667C9.7 36.667 0 46.367 0 58.333 0 70.3 9.7 80 21.667 80c11.966 0 21.666-9.7 21.666-21.667v.001c-.014-11.96-9.706-21.652-21.666-21.667zM30 60.833h-5a.833.833 0 00-.833.834v5a2.5 2.5 0 11-5 0v-5a.833.833 0 00-.834-.834h-5a2.5 2.5 0 110-5h5c.46 0 .834-.373.834-.833v-5a2.5 2.5 0 115 0v5c0 .46.373.833.833.833h5a2.5 2.5 0 110 5z"/></g></svg>
</template>

<script>
export default {
  props: {
    remove: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: false
    },
    drop: {
      type: Boolean,
      default: false
    }
  }
};
</script>
